import { render } from "./LogsScreen.vue?vue&type=template&id=018e4596&scoped=true"
import script from "./LogsScreen.vue?vue&type=script&lang=js"
export * from "./LogsScreen.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-018e4596"

export default script